/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 23/9/2020
 */
import Link from "@tiptap/extension-link"
// import {Link} from '@tiptap/extension-link'
// import { Mark, Plugin } from '@tiptap/vue-3'
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { find } from 'linkifyjs';
import { combineTransactionSteps, getChangedRanges, findChildrenInRange, getMarksBetween, getAttributes} from '@tiptap/core';
// import { updateMark, removeMark, pasteRule } from 'tiptap-commands'
// // import { getMarkAttrs } from 'tiptap-utils'


function autolink(options) {
	return new Plugin({
		key: new PluginKey('autolink'),
		appendTransaction: (transactions, oldState, newState) => {
			const docChanges = transactions.some(transaction => transaction.docChanged) && !oldState.doc.eq(newState.doc);
			const preventAutolink = transactions.some(transaction => transaction.getMeta('preventAutolink'));
			if (!docChanges || preventAutolink) {
				return;
			}
			const { tr } = newState;
			const transform = combineTransactionSteps(oldState.doc, [...transactions]);
			const changes = getChangedRanges(transform);
			changes.forEach(({ newRange }) => {
				// Now let’s see if we can add new links.
				const nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, node => node.isTextblock);
				let textBlock;
				let textBeforeWhitespace;
				if (nodesInChangedRanges.length > 1) {
					// Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
					textBlock = nodesInChangedRanges[0];
					textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
				}
				else if (nodesInChangedRanges.length
					// We want to make sure to include the block seperator argument to treat hard breaks like spaces.
					&& newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ').endsWith(' ')) {
					textBlock = nodesInChangedRanges[0];
					textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
				}
				if (textBlock && textBeforeWhitespace) {
					const wordsBeforeWhitespace = textBeforeWhitespace.split(' ').filter(s => s !== '');
					if (wordsBeforeWhitespace.length <= 0) {
						return false;
					}
					const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
					const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
					if (!lastWordBeforeSpace) {
						return false;
					}
					find(lastWordBeforeSpace)
						.filter(link => link.isLink)
						// Calculate link position.
						.map(link => ({
							...link,
							from: lastWordAndBlockOffset + link.start + 1,
							to: lastWordAndBlockOffset + link.end + 1,
						}))
						// ignore link inside code mark
						.filter(link => {
							if (!newState.schema.marks.code) {
								return true;
							}
							return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
						})
						// validate link
						.filter(link => {
							if (options.validate) {
								return options.validate(link.value);
							}
							return true;
						})
						// Add link mark.
						.forEach(link => {
							if (getMarksBetween(link.from, link.to, newState.doc).some(item => item.mark.type === options.type)) {
								return;
							}
							tr.addMark(link.from, link.to, options.type.create({
								href: link.href,
							}));
						});
				}
			});
			if (!tr.steps.length) {
				return;
			}
			return tr;
		},
	});
}
function clickHandler(options) {
	return new Plugin({
		key: new PluginKey('handleClickLinkEx'),
		props: {
			handleClick: (view, pos, event) => {
				console.log("LinkEx handleClick1: event = ", event)
				if (event.button !== 0) {
					return false;
				}
				console.log("LinkEx handleClick2: event = ", event)

				let depth = 3
				let eventTarget = event.target;
				console.log("LinkEx handleClick3: eventTarget.nodeName = ", eventTarget.nodeName)
				while (eventTarget && eventTarget.nodeName !== 'A' && depth > 0) {
					eventTarget = eventTarget.parentNode;
					console.log("LinkEx handleClick3: eventTarget.nodeName = ", eventTarget.nodeName)
					depth--;
				}
				if (!eventTarget || depth <= 0) {
					return false;
				}
				console.log("LinkEx handleClick3: event = ", event)
				const attrs = getAttributes(view.state, options.type.name);
				const link = event.target;
				const href = attrs.href;
				const target = attrs.target;
				if (link && href && options.clickHandler) {
					if (view.editable) {
						options.clickHandler(href, target)
					}
					return true;
				}
				return false;
			},
		},
	});
}

const LinkEx = Link.extend( {

	inclusive: false,

	addProseMirrorPlugins() {
		const plugins = [];
		if (this.options.autolink) {
			plugins.push(autolink({
				type: this.type,
				validate: this.options.validate,
			}));
		}
		// if (this.options.openOnClick) {
			plugins.push(clickHandler({
				type: this.type,
				clickHandler: this.options.clickHandler,
			}));
		// }
		console.log("LinkEx addProseMirrorPlugins: plugins = ", plugins)
		console.log("LinkEx addProseMirrorPlugins: this.options = ", this.options)
		return plugins;
	},



})

export default LinkEx
